import React from 'react';

const LoadingComponent = () => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>Loading flashcards...</p>
    </div>
  );
};

export default LoadingComponent;
